const defaultState = () => ({
  loading: false,
  saving: false,
  threats: [],
})

const excludeFields = ['loading', 'saving']

export { defaultState, excludeFields }

export default defaultState
